import { render, staticRenderFns } from "./SchoolAdmins.vue?vue&type=template&id=3ed7c510"
import script from "./SchoolAdmins.vue?vue&type=script&lang=js"
export * from "./SchoolAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports